import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const jpdBlueprintsFeedbackBannerEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-banner-jpd-blueprints-feedback" */ './src/ui/banner/index.tsx'
			),
	),
	getPreloadProps: () => ({}),
});
